import { USER_SUCCESS, USER_LOGOUT } from '../actions/user'

const state = {
  userGroups: localStorage.getItem('audiens-bourse-etudes-user-group') || '',
  userFirstName: localStorage.getItem('audiens-bourse-etudes-user-first_name') || '',
  userLastName: localStorage.getItem('audiens-bourse-etudes-user-last_name') || '',
  userUsername: localStorage.getItem('audiens-bourse-etudes-user-username') || '',
}

const getters = {
  getUserGroups: state => state.userGroups,
  getUserFirstName: state => state.userFirstName,
  getUserLastName: state => state.userLastName,
  getUserUsername: state => state.userUsername,

}

const actions = {
  [USER_LOGOUT]: ({commit}) => {
    commit(USER_LOGOUT)
  }
}

const mutations = {
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.userGroups = JSON.stringify(resp.groups)
    localStorage.setItem('audiens-bourse-etudes-user-group', JSON.stringify(resp.groups))
    state.userFirstName = resp.first_name
    localStorage.setItem('audiens-bourse-etudes-user-first_name', resp.first_name)
    state.userLastName = resp.last_name
    localStorage.setItem('audiens-bourse-etudes-user-last_name', resp.last_name)
    state.userUsername = resp.username
    localStorage.setItem('audiens-bourse-etudes-user-username', resp.username)

  },
  [USER_LOGOUT]: (state) => {
    state.userGroups = ''
    localStorage.removeItem('audiens-bourse-etudes-user-group')
    state.userFirstName = ''
    localStorage.removeItem('audiens-bourse-etudes-user-first_name')
    state.userLastName = ''
    localStorage.removeItem('audiens-bourse-etudes-user-last_name')
    state.userUsername = ''
    localStorage.removeItem('audiens-bourse-etudes-user-username')
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
